module.exports = __webpack_public_path__ + "img/logo-wit.f74aa542.webp";